module.exports = __webpack_public_path__ + "static/media/Lato-Italic.f28f2d64.woff";